module.exports = __webpack_public_path__ + "img/labmem_img_bg.8a14e805.png";